







































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { VIPCapabilityRefreshMixin } from '@/mixins/VIPCapabilityMixin';
import IpTree from "../ip/IpTree.vue";
import CapabilityStatusBadge from "./CapabilityStatusBadge.vue";
import { db, VIPCapability, VIPIp, VIPCapabilityRest } from "@/loader";

let _id: number = 0;

@Component({
	components: {
		IpTree,
		CapabilityStatusBadge,
	}
})
export default class CapabilitiesTreeWidget extends Mixins(VIPCapabilityRefreshMixin) {
	@Prop({ type: String, default: () => `capability_tree_widget_${++_id}` })
	public id!: string;

	@Prop({ type: String, default: "Capacités" })
	public title!: string;

	@Prop({ type: String, default: null })
	public accordion!: string | null;

	@Prop({ type: Boolean, default: false })
	public visible!: boolean;

	public loading: boolean = false;

	public get capability() {
		return (ip: VIPIp) => this.capabilities.find(c => ip && c.ip === ip) || null;
	}

	public get capabilities(): VIPCapability[] {
		return db.capabilities.list.filter(c => c.id < 0);
	}

	public get totalRows(): number {
		return this.capabilities.length;
	}

	public get ips(): VIPIp[] {
		return <VIPIp[]>this.capabilities.map(c => c.ip).filter(x => !!x);
	}

	public show() {
		this.$root.$emit("bv::toggle::collapse", this.id);
	}

	public viewCapByIp(ip?: VIPIp | null) {
		if (ip) {
			let cap = this.capabilities.find(c => c.ip === ip);
			if (cap) {
				this.$router.push({ name: "Capability", params: { id: cap.id.toString() } });
			}
		}
	}

	public refresh() {
		this.loading = true;
		VIPCapabilityRest.getPossibilities().finally(() => {
			this.loading = false;
		});
	}

	public mounted() {
		if (!this.capabilities.length) {
			this.refresh();
		}
	}
}
